module.exports = __webpack_public_path__ + "img/88.ac9d470d.png";